module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<div class=\"texts\">\n<% if (model.title!=\"\") { %>\n<div class=\"title\" id=\"<%- String(model.title).toLowerCase().replace(/\\s+/g, '-') %>\"><h2><%- model.title %></h2></div>\n<% } %>\n<div class=\"full\">\n<% if (environment.style == \"desktop\") {  %>\n<%- model.textLeft %>\n<%- model.textRight %>\n<% } else { %>\n<%- model.textMobile %>\n<% } %>\n</div>\n</div>\n</div>"
  , __filename = "components/templates/standard/2-col-html/2-col-html.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n<div class=\"texts\">\n")
    ; __line = 3
    ;  if (model.title!="") { 
    ; __append("\n<div class=\"title\" id=\"")
    ; __line = 4
    ; __append( String(model.title).toLowerCase().replace(/\s+/g, '-') )
    ; __append("\"><h2>")
    ; __append( model.title )
    ; __append("</h2></div>\n")
    ; __line = 5
    ;  } 
    ; __append("\n<div class=\"full\">\n")
    ; __line = 7
    ;  if (environment.style == "desktop") {  
    ; __append("\n")
    ; __line = 8
    ; __append( model.textLeft )
    ; __append("\n")
    ; __line = 9
    ; __append( model.textRight )
    ; __append("\n")
    ; __line = 10
    ;  } else { 
    ; __append("\n")
    ; __line = 11
    ; __append( model.textMobile )
    ; __append("\n")
    ; __line = 12
    ;  } 
    ; __append("\n</div>\n</div>\n</div>")
    ; __line = 15
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/standard/2-col-html/2-col-html.ejs

}